import { gql, QueryHookOptions, useQuery } from '@apollo/client'
import { ProductDropsQuery, ProductDropsQueryVariables } from 'types/graphql'
import { productDropFragment } from './productDropFragment'

export const productDropsQuery = gql`
  ${productDropFragment}

  query ProductDrops($filter: ProductDropFilter, $sort: ProductDropSortOrder, $take: Int, $exclude: [ID!], $skip: Int, $isPromoted: Boolean) {
    productDrops(isPromoted: $isPromoted, sort: $sort, filter: $filter, exclude: $exclude, skip: $skip, take: $take) {
      ...ProductDropFields
    }
  }
`

export const useProductDrops = (options: QueryHookOptions<ProductDropsQuery, ProductDropsQueryVariables>) =>
  useQuery<ProductDropsQuery, ProductDropsQueryVariables>(productDropsQuery, options)
